/**
 * Aide contextuelle — Section ALSO Marketplace (revente licences cloud).
 */

const alsoHelp = {
  '/also/billing': {
    title: 'ALSO — Facturation licences',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Vue mensuelle de la consommation ALSO Marketplace par client. Chaque carte montre les licences actives sur la periode (M365, Adobe, Acronis, etc.) avec qty + prix unitaire + total. Le bouton **Injecter** ajoute ces lignes a une facture brouillon Odoo en un clic.`,
      },
      {
        heading: 'Sélectionner une période',
        content: `Les boutons en haut listent les periodes pour lesquelles un agregat est calcule. La plus recente est selectionnee par defaut. Si rien n'est affiche, lance la **Synchronisation** depuis le bouton en haut a droite.`,
      },
      {
        heading: 'Statuts de carte',
        content: `**Lie Odoo** : tk_clients lie + facture brouillon trouvee, pret a injecter.\n**Pas de brouillon** : compte lie mais aucune facture brouillon Odoo (creer une dans Odoo).\n**Pas de partenaire Odoo** : tk_clients existe mais pas lie a Odoo (cliquer **Lier a Odoo** sur la suggestion).\n**Societe non liee** : compte ALSO sans fiche tk_clients (creer la fiche dans Gestion / Societes puis ajouter \`also_account_id\`).`,
      },
      {
        heading: 'Idempotence des injections',
        content: `Une injection est tracee dans \`col_also_injections\` avec une cle unique (period, invoice_id, also_account_id). Si tu re-cliques Injecter sur la meme periode + meme facture, le portail refuse (409) et affiche **Deja injecte**. Cette regle protege contre les doublons en cas de double-clic ou refresh.`,
      },
    ],
    admin: [
      {
        heading: 'Endpoints',
        content: `\`GET /api/billing/also/periods\` — Liste les periodes disponibles.\n\`GET /api/billing/also/aggregate?period=YYYY-MM\` — Aggregats par client.\n\`GET /api/billing/also/odoo-invoices?also_account_id=...\` — Recherche factures brouillons Odoo.\n\`POST /api/billing/also/inject\` — Injection (period, invoice_id, also_account_id).\n\`POST /api/billing/also/sync\` — Sync manuelle complete (admin).`,
      },
      {
        heading: 'Mapping SKU → produit Odoo',
        content: `Les lignes Odoo sont creees avec un \`product_id\` resolu via \`col_also_sku_mapping\`. Strategie : par grand vendor (M365, Adobe, ...) + fallback "Licence ALSO". Voir page **ALSO Administration** pour editer les mappings.`,
      },
      {
        heading: 'Statuts ALSO factures',
        content: `Une subscription compte dans l'agregat si :\n- \`status\` ∈ {Active, Suspended} (pas Pending, pas Terminated)\n- \`start_date\` <= fin de periode\n- \`end_date\` est null OU >= debut de periode\n\nLe pattern reproduit la regle ALSO de facturation : les comptes suspendus restent factures tant qu'ils ne sont pas terminés.`,
      },
    ],
  },

  '/also/licences': {
    title: 'ALSO — Gestion licences',
    user: [
      {
        heading: 'A quoi sert cette page ?',
        content: `Listing des comptes ALSO synchronises (cache local de \`/GetCompanies\`). Chaque ligne montre nom + TVA + nb subscriptions actives + lien vers la fiche tk_clients du portail. Clic sur une ligne → detail (subscriptions, utilisateurs, donnees brutes).`,
      },
      {
        heading: 'Synchroniser',
        content: `Le bouton **Synchroniser** lance un appel ALSO complet : pull de toutes les companies + leurs subscriptions, mise a jour du cache, recalcul des agregats du mois. Operation idempotente, peut etre relancee a la demande. Sync auto : companies 4×/j, subscriptions 1×/j.`,
      },
      {
        heading: 'Compte non lié à tk_clients',
        content: `Le matching automatique se fait sur (1) VAT exact, (2) nom exact, (3) alias. Si aucun match, la colonne **Lien tk_clients** affiche **Non lie** en rouge. Solution : creer la fiche dans Gestion / Societes ou ajouter le bon \`vat_number\` sur la fiche existante, puis re-synchroniser.`,
      },
    ],
    admin: [
      {
        heading: 'Endpoints',
        content: `\`GET /api/also/companies?search=&page=&page_size=\` — Liste paginated.\n\`GET /api/also/companies/{also_account_id}\` — Fiche detail.\n\`POST /api/also/companies/{id}/refresh\` — Force le pull individuel.`,
      },
      {
        heading: 'Schema col_also_companies',
        content: `\`{also_account_id (PK), name, vat_id, country, reseller_ref, tk_client_id (FK), odoo_partner_id (cache), organization_id, last_synced_at, raw}\`. Index unique sur \`also_account_id\`, sparse sur \`vat_id\` et \`tk_client_id\`.`,
      },
    ],
  },

  '/also/companies/:id': {
    title: 'ALSO — Détail compte',
    user: [
      {
        heading: 'Onglets',
        content: `**Subscriptions** : toutes les licences actives + historique. Vendor, SKU, qty, prix, statut, periode.\n**Utilisateurs** : appel direct API ALSO \`/GetUsers\` (Phase 3 : creation/modification possible).\n**Donnees brutes** : payload ALSO complet pour debug.`,
      },
      {
        heading: 'Rafraîchir',
        content: `Force un pull de cette company uniquement (sans attendre la sync auto). Utile apres une modification cote ALSO (ajout licence, changement qty) pour voir les nouveaux chiffres en temps reel.`,
      },
    ],
    admin: [
      {
        heading: 'Phase 3 — Provisioning (a venir)',
        content: `Cette page accueillera les actions :\n- Creer un utilisateur (\`POST /api/also/companies/{id}/users\`)\n- Ajouter une licence (\`POST /api/also/companies/{id}/subscriptions\` apres ValidateFields)\n- Modifier la qty d'une subscription (\`PATCH /api/also/subscriptions/{sub_id}\`)\n\nLes endpoints existent deja cote backend (permission \`also.manage\`), seuls les formulaires UI restent a faire.`,
      },
    ],
  },

  '/also/admin': {
    title: 'ALSO — Administration',
    user: [
      {
        heading: 'Mapping SKU',
        content: `Definit comment chaque SKU ALSO est resolu vers un produit Odoo lors de l'injection facture. Strategie : par grand vendor (Microsoft, Adobe, Acronis, ...) + fallback global. Le mapping est consulte a chaque injection — modifier un mapping influence les futures injections, pas les precedentes.`,
      },
      {
        heading: 'Tester la connexion',
        content: `Smoke test : verifie que les credentials ALSO du Vault sont valides + que l'API repond + mesure la latence. A faire si la sync auto echoue plusieurs fois de suite.`,
      },
      {
        heading: 'SKU passes par le fallback',
        content: `Liste des SKU non couverts par un mapping specifique → tombent sur le fallback. Compteur \`hit_count\` indique le volume. Si un SKU repete tombe en fallback, ajouter un mapping vendor ou pattern dedie pour ameliorer le reporting comptable.`,
      },
    ],
    admin: [
      {
        heading: 'Configuration credentials',
        content: `1. Creer un item dans le Vault (\`/vault\`) categorie **api_key** : login = api.user@meteris.fr, password, url = base ALSO API.\n2. Recuperer l'\`item.id\` dans le Vault.\n3. Definir 2 env vars Portainer (stack 104) :\n   - \`ALSO_API_BASE_URL\` = base URL ALSO (sans trailing slash)\n   - \`ALSO_VAULT_ITEM_ID\` = l'ID copie\n4. Redeployer le backend (ssh docker1 sudo /opt/deploy-portail.sh backend).\n5. Cliquer **Tester connexion** sur cette page.`,
      },
      {
        heading: 'Endpoints admin',
        content: `\`GET /api/also/admin/test-connection\` — Smoke ping ALSO.\n\`GET/POST/DELETE /api/also/admin/sku-mapping\` — CRUD mappings.\n\`GET /api/also/admin/sync-log\` — Historique runs.\n\`GET /api/also/admin/fallback-warnings\` — SKU non mappes.\n\`POST /api/also/admin/reset-cache\` — Vide caches credentials + token session.`,
      },
      {
        heading: 'Tâches schedulées',
        content: `\`also_companies_sync\` — 4×/j (21600s) — Pull \`/GetCompanies\`.\n\`also_subscriptions_sync\` — 1×/j (86400s) — Pull \`/GetSubscriptions\` pour chaque company.\n\`also_period_aggregate\` — 1×/h — Recompute \`col_also_invoice_aggregates\` du mois courant + precedent.\n\nToutes categorie \`billing\`, alertes auto en cas d'erreur partielle.`,
      },
    ],
  },
};

export default alsoHelp;
